import { collectDashboardAddins } from "./addinHelper";
import type { UserService } from "./users";
import type { DatabaseCache } from "../services/databaseCache";
import type { IDashboardAddin } from "../model/Addin";

/**
 * Collect dashboard addins from the SystemSettings-based path.
 * Extracted from DashboardView so the view doesn't need to know about the data source.
 */
export function getAddinsForDashboard(
    databaseCache: DatabaseCache,
    userService: UserService
): IDashboardAddin[] {
    return databaseCache ? collectDashboardAddins(databaseCache, userService) : [];
}
